import { Icon, IconProps } from "../";

export const ArrowBackIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L4.96967 11.4697C4.67678 11.7626 4.67678 12.2374 4.96967 12.5303L10.9697 18.5303C11.2626 18.8232 11.7374 18.8232 12.0303 18.5303C12.3232 18.2374 12.3232 17.7626 12.0303 17.4697L7.31066 12.75H18.75C19.1642 12.75 19.5 12.4142 19.5 12C19.5 11.5858 19.1642 11.25 18.75 11.25H7.31066L12.0303 6.53033Z"
      />
    </Icon>
  );
};
